import { Box, MenuItem, SelectChangeEvent, Typography, useTheme } from '@mui/material';
import { AlertCluster } from 'app/shared/model/enumerations/alert-cluster.model';
import React from 'react';
import { translate } from 'react-jhipster';
import { SelectDefault } from '../select-default/SelectDefault';

interface EnumSelectAlertClusterProps {
  setCluster: (status: AlertCluster) => void;
  cluster: AlertCluster | string;
}

export const EnumSelectAlertCluster: React.FC<EnumSelectAlertClusterProps> = ({ setCluster, cluster }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        [theme.breakpoints.up('sm')]: {
          maxWidth: '250px',
        },
      }}
    >
      <Typography textAlign="left" color="text.primary" fontWeight="600" fontSize="16px">
        Cluster
      </Typography>
      <SelectDefault
        value={cluster}
        onChange={(event: SelectChangeEvent) => {
          setCluster(event.target.value as AlertCluster);
        }}
      >
        {<MenuItem sx={{ height: '36px' }} value="" key="0" />}
        {Object.values(AlertCluster).map(clusterValue => (
          <MenuItem key={clusterValue} value={clusterValue}>
            {translate(`fleetSenseApp.AlertCluster.${clusterValue}`)}
          </MenuItem>
        ))}
      </SelectDefault>
    </Box>
  );
};
